import axios from '@/axios';

export default {
  fetchSubscriptionTiers(_context, params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/subscription-tiers', { params })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchSubscriptionTierById(_context, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/v1/subscription-tiers/${id}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  createSubscriptionTier(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/subscription-tiers', data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateSubscriptionTier(_context, { id, data }) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/v1/subscription-tiers/${id}`, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  deleteSubscriptionTier(_context, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/v1/subscription-tiers/${id}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

